import Order from './Order.gql';

export default Order;
